import { client } from '../../apiClient';
import { MonitorEventLogResponse } from '../../../models/monitor/MonitorEventLogResponse';
import { format } from 'date-fns';
import { getDefaultRange } from '../../../utils/utils';
import { MonitorPeriod } from '../../../types/monitor/MonitorPeriod';
import { ChatType } from '../../../types/monitor/ChatType';

export const MONITOR_EVENTS_ENDPOINT = '/events';

export const getEvents = async (
  projectId: number,
  from?: Date | null,
  to?: Date | null,
  period?: MonitorPeriod | 'DAILY',
  type?: ChatType | 'ALL'
): Promise<MonitorEventLogResponse[]> => {
  const defaultRange = getDefaultRange();
  from = from ? new Date(from) : defaultRange[0];
  to = to ? new Date(to) : defaultRange[1];

  const formattedFrom = format(from, 'yyyy-MM-dd');
  const formattedTo = format(to, 'yyyy-MM-dd');

  const { data } = await client(true, true).get<MonitorEventLogResponse[]>(
    `${MONITOR_EVENTS_ENDPOINT}/${projectId}/${formattedFrom}/${formattedTo}/${period}/${type}`
  );

  return data;
};
